module.exports = __webpack_public_path__ + "static/p11_sombraPaja-5f112e6a3b80d5f03a39036660047582.png";